import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from 'src/app/auxiliares/auxiliares.module';
import { ListadoLogIntegracionSoflexComponent } from './listado-log-integracion-soflex/listado-log-integracion-soflex.component';
import { DetalleLogIntegracionSoflexComponent } from './detalle-log-integracion-soflex/detalle-log-integracion-soflex.component';
import { LogIntegracionSoflexRoutingModule } from './log-integracion-soflex.routing.module';

@NgModule({
  declarations: [
    ListadoLogIntegracionSoflexComponent,
    DetalleLogIntegracionSoflexComponent,
  ],
  imports: [CommonModule, AuxiliaresModule, LogIntegracionSoflexRoutingModule],
})
export class LogIntegracionSoflexModule {}
